var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60563 16.0874H13.2834V30.9093H8.60563V16.0874ZM10.8252 14.2336H10.7915C9.09781 14.2336 8 13.1006 8 11.6643C8 10.1999 9.13025 9.09088 10.8575 9.09088C12.5833 9.09088 13.6445 10.1971 13.6783 11.6602C13.6783 13.0964 12.5833 14.2336 10.8251 14.2336H10.8252ZM32 30.9091H26.6937V23.2391C26.6937 21.2315 25.8641 19.8609 24.0395 19.8609C22.6439 19.8609 21.8679 20.7858 21.5064 21.677C21.371 21.9969 21.3939 22.4426 21.3939 22.8883V30.9089H16.1394V16.0871H21.3942V18.4132C21.7047 17.3962 23.3836 15.9446 26.0636 15.9446C29.3879 15.9446 31.9998 18.0764 31.9998 22.6674V30.9089L32 30.9091Z",
    fill: "#007EBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/Social.c6b36591d341797b488757da228b3008.svg";
export { ForwardRef as ReactComponent };